import { useState } from "react";
import copy from 'copy-to-clipboard';
import { Tooltip } from "@chr/eds-react";
import { useTranslation } from "@chr/online-shared-ui-localizations";
import { Button as MuiButton, Icon, Stack, Typography, useTheme, Box } from "@mui/material";

export interface CopyToClipboardProps {
  text: string;
}

const POST_COPY_TIMEOUT_MS = 4000;
const POST_COPY_TRANSITION_MS = 1500;

export const CopyToClipboard = ({text}: CopyToClipboardProps) => {
  const translate = useTranslation();
  const theme = useTheme();
  const [ copied, setCopied ] = useState(false);
  const [ inTransition, setInTransition ] = useState(false);

  const copyTo = () => {
    setCopied(true);
    copy(text);

    setTimeout(()=>{
      setInTransition(true);
      setCopied(false);
    }, POST_COPY_TIMEOUT_MS)

    setTimeout(()=>{
      setInTransition(false);
    }, POST_COPY_TIMEOUT_MS + POST_COPY_TRANSITION_MS)
  }
  
  return (
      <MuiButton
        onClick={copyTo}
        disabled={copied || inTransition}
        sx={[
          {          
            paddingY: 0,
            paddingX: 0,
            width: '100%',
            height: '48px',
          }, 
          copied ? 
          {
            backgroundColor: theme.palette.grey[800],
            '#copy-text': { color: theme.palette.common.white, paddingLeft: 2 },
            '#content-copy-icon': { backgroundColor: theme.palette.grey[50] },
          } : 
          {
            backgroundColor: theme.palette.grey[50],
            '#copy-text': { color: theme.palette.grey[700], wordBreak: 'break-all'},
            '#content-copy-icon': { backgroundColor: "inherit" },
          },
          inTransition && {
            transition: (POST_COPY_TRANSITION_MS/1000 + 's')
          }
        ]}
      >
        <Tooltip title={translate('Copy link to clipboard')}>
        <Stack 
          direction="row" 
          justifyContent="space-between"
          alignItems="center"
          textAlign= "left"
          width="100%"
          paddingLeft={1}
        >
          <Typography id="copy-text" variant="body2">
            {copied ? translate('Link copied') : text}
          </Typography>
          <Box 
            id="content-copy-icon" 
            display="flex"
            justifyContent="center"
            alignItems= 'center' 
            color= {theme.palette.grey[700]}
            minWidth= '45px' 
            width= '45px' 
            height= '49px' 
            sx={{
              borderTopRightRadius: '4px',
              borderBottomRightRadius: '4px',
            }}            
          >
            <Icon data-testid="icon">content_copy_outlined_icon</Icon>
          </Box>
        </Stack>
        </Tooltip>
      </MuiButton>
  );
};
